export function getCsrfToken() {
  const tokenElement = document.querySelector('meta[name="csrf-token"]')
  if (!tokenElement) {
    return null
  }

  return tokenElement.content
}
